let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("byFyU")).then(() => parcelRequire('dXEk5'));